import { useMutation } from "react-query";
import axios from "axios";

const verifyMarketplacePayment = async ({ reference, orderId }) => {
  const params = orderId ? { orderId } : {};
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/payment/verify/${encodeURIComponent(reference)}`,
    { params, timeout: 45000 }
  );
  return response.data;
};

const useVerifyMarketplacePayment = () => {
  return useMutation((payload) => verifyMarketplacePayment(payload));
};

export default useVerifyMarketplacePayment;
